const fr = {
  // ============================================================
  // COMMON — Partagé dans toute l'application
  // ============================================================
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    add: 'Ajouter',
    remove: 'Retirer',
    close: 'Fermer',
    confirm: 'Confirmer',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    search: 'Rechercher',
    filter: 'Filtrer',
    clear: 'Effacer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    update: 'Mettre à jour',
    refresh: 'Actualiser',
    export: 'Exporter',
    import: 'Importer',
    download: 'Télécharger',
    upload: 'Téléverser',
    print: 'Imprimer',
    copy: 'Copier',
    yes: 'Oui',
    no: 'Non',
    ok: 'OK',
    done: 'Terminé',
    select: 'Sélectionner',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    noResults: 'Aucun résultat trouvé',
    noData: 'Aucune donnée disponible',
    required: 'Obligatoire',
    optional: 'Facultatif',
    actions: 'Actions',
    details: 'Détails',
    overview: 'Vue d\'ensemble',
    summary: 'Résumé',
    total: 'Total',
    all: 'Tous',
    none: 'Aucun',
    name: 'Nom',
    type: 'Type',
    status: 'Statut',
    date: 'Date',
    time: 'Heure',
    description: 'Description',
    notes: 'Notes',
    comments: 'Commentaires',
    category: 'Catégorie',
    priority: 'Priorité',
    nation: 'Nation',
    country: 'Pays',
    email: 'E-mail',
    phone: 'Téléphone',
    address: 'Adresse',
    location: 'Emplacement',
    coordinates: 'Coordonnées',
    latitude: 'Latitude',
    longitude: 'Longitude',
    from: 'De',
    to: 'À',
    createdAt: 'Créé',
    updatedAt: 'Mis à jour',
    createdBy: 'Créé par',
    modifiedBy: 'Modifié par',
    active: 'Actif',
    inactive: 'Inactif',
    enabled: 'Activé',
    disabled: 'Désactivé',
    showing: 'Affichage',
    of: 'de',
    page: 'Page',
    perPage: 'par page',
    rows: 'lignes',
    items: 'éléments',
    results: 'résultats',
    sortBy: 'Trier par',
    ascending: 'Croissant',
    descending: 'Décroissant',
    viewAll: 'Voir tout',
    viewDetails: 'Voir les détails',
    goBack: 'Retour',
    learnMore: 'En savoir plus',
    seeMore: 'Voir plus',
    showMore: 'Afficher plus',
    showLess: 'Afficher moins',
    expandAll: 'Tout développer',
    collapseAll: 'Tout réduire',
    copied: 'Copié !',
    saved: 'Enregistré !',
    deleted: 'Supprimé !',
    updated: 'Mis à jour !',
    created: 'Créé !',
    success: 'Succès',
    warning: 'Avertissement',
    info: 'Info',
    danger: 'Danger',
    unknown: 'Inconnu',
    notAvailable: 'N/D',
    never: 'Jamais',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    tomorrow: 'Demain',
    now: 'Maintenant',
    ago: 'il y a',
    justNow: 'à l\'instant',
    minutesAgo: 'il y a {{count}} min',
    hoursAgo: 'il y a {{count}} h',
    daysAgo: 'il y a {{count}} j',
    monthsAgo: 'il y a {{count}} mois',
    id: 'ID',
    version: 'Version',
    language: 'Langue',
    theme: 'Thème',
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    failedToLoad: 'Échec du chargement des données',
    failedToSave: 'Échec de l\'enregistrement',
    failedToDelete: 'Échec de la suppression',
    failedToUpdate: 'Échec de la mise à jour',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    confirmAction: 'Êtes-vous sûr ?',
    unsavedChanges: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?',
    pageNotFound: '404 - Page non trouvée',
    pageNotFoundDesc: 'La page que vous recherchez n\'existe pas.',
    backToDashboard: 'Retour au tableau de bord',
    characters: 'caractères',
    maxCharacters: 'Maximum {{max}} caractères',
    remaining: '{{count}} restant(s)',
    selected: '{{count}} sélectionné(s)',
    of_total: '{{count}} sur {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — En-tête, barre latérale, menus
  // ============================================================
  nav: {
    dashboard: 'Tableau de bord',
    requests: 'Demandes',
    transports: 'Transports',
    myPatients: 'Mes patients',
    statistics: 'Statistiques',
    flow: 'Flux',
    resources: 'Resources',
    exercise: 'Exercice',
    administration: 'Administration',
    map: 'Carte',
    info: 'Info',
    users: 'Utilisateurs',
    assets: 'Moyens de transport',
    hubs: 'Hubs',
    treatmentFacilities: 'Établissements de soins',
    patientImport: 'Importation de patients',
    assetTemplates: 'Modèles de moyens',
    dayTemplates: 'Modèles de journée',
    announcementTicker: 'Bandeau d\'annonces',
    exerciseStatistics: 'Statistiques de l\'exercice',
    settings: 'Paramètres',
    auditLog: 'Journal d\'audit',
    exerciseControl: 'Contrôle de l\'exercice',
    dataSync: 'Synchronisation des données',
    documentation: 'Documentation',
    support: 'Support',
    about: 'À propos',
    assetContracts: 'Asset Contracts',
    notifications: 'Notifications',
    schedules: 'Plannings',
    capacityPlanning: 'Planification des capacités',
    transportPlanning: 'Planification des transports',
    transportBooking: 'Réservation de transport',
    flowDiagram: 'Diagramme de flux',
    changePassword: 'Changer le mot de passe',
    missions: 'Missions',
    startPoints: 'Points de départ',
    hospital: 'Hôpital',
  },

  // ============================================================
  // AUTH — Connexion, mot de passe, session
  // ============================================================
  auth: {
    login: 'Connexion',
    logout: 'Déconnexion',
    logoutNow: 'Se déconnecter maintenant',
    loggingIn: 'Connexion en cours...',
    loginFailed: 'Échec de la connexion',
    email: 'E-mail',
    password: 'Mot de passe',
    username: 'Nom d\'utilisateur',
    enterEmail: 'Saisissez votre adresse e-mail',
    enterPassword: 'Saisissez votre mot de passe',
    enterUsername: 'Saisissez votre nom d\'utilisateur',
    forgotPassword: 'Mot de passe oublié ?',
    forgotPasswordTitle: 'Mot de passe oublié',
    forgotPasswordDesc: 'Saisissez votre nom d\'utilisateur et votre adresse e-mail. Si les deux correspondent, les administrateurs seront informés pour réinitialiser votre mot de passe.',
    requestPasswordReset: 'Demander la réinitialisation du mot de passe',
    sending: 'Envoi en cours...',
    backToLogin: 'Retour à la connexion',
    pleaseWait: 'Veuillez patienter avant de réessayer.',
    requestFailed: 'Échec de la demande',
    credentialsMatch: 'Si les identifiants correspondent, les administrateurs ont été informés.',
    forAccess: 'Pour obtenir un accès, veuillez contacter votre administrateur système.',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    passwordChanged: 'Mot de passe modifié avec succès',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    changingPassword: 'Modification en cours...',
    mustChangePassword: 'Vous devez changer votre mot de passe avant de continuer.',
    sessionExpiring: 'Session expirant bientôt',
    sessionExpireText: 'Votre session expirera dans <strong>{{time}}</strong>. Veuillez enregistrer votre travail et vous reconnecter pour continuer.',
    dismiss: 'Fermer',
    switchNation: 'Changer de nation',
    returnTo: 'Retour à {{nation}}',
    viewingAs: 'Vous consultez en tant que',
    loggedInAs: 'connecté en tant que {{nation}}',
    trainingMode: 'UNIQUEMENT À DES FINS D\'ENTRAÎNEMENT',
    dedication: 'Créé avec passion et dévouement pour la profession',
  },

  // ============================================================
  // ROLES — Rôles utilisateur et libellés
  // ============================================================
  roles: {
    admin: 'Administrateur système',
    excon: 'Contrôleur d\'exercice',
    eu: 'Coordinateur UE',
    planner: 'Planificateur',
    hub: 'Gestionnaire de hub',
    nation: 'Nation',
    readOnly: 'Lecture seule',
    systemAdmin: 'Administrateur système',
    transportPlanner: 'Planificateur de transport',
    systemRoles: 'Rôles système',
  },

  // ============================================================
  // STATUS — Statuts des demandes, offres, missions
  // ============================================================
  status: {
    draft: 'Brouillon',
    underReview: 'En cours de révision',
    published: 'Publiée',
    underSelection: 'En cours de sélection',
    accepted: 'Acceptée',
    planned: 'Planifiée',
    inTransit: 'En transit',
    completed: 'Terminée',
    closed: 'Clôturée',
    withdrawn: 'Retirée',
    pending: 'En attente',
    rejected: 'Rejetée',
    cancelled: 'Annulée',
    active: 'Active',
    inactive: 'Inactive',
    review: 'Révision',
    selection: 'Sélection',
    transit: 'Transit',
  },

  // ============================================================
  // CATEGORIES — Catégories de demandes
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personnel',
    material: 'Matériel',
    equipment: 'Équipement',
    other: 'Autre',
    news: 'Actualités',
  },

  // ============================================================
  // URGENCY — Niveaux d'urgence
  // ============================================================
  urgency: {
    routine: 'Routine',
    priority: 'Prioritaire',
    urgent: 'Urgent',
    immediate: 'Immédiat',
  },

  // ============================================================
  // ASSETS — Types de moyens de transport
  // ============================================================
  assetTypes: {
    train: 'Train',
    ship: 'Navire',
    aircraft: 'Aéronef',
    bus: 'Bus',
    ambulance: 'Ambulance',
    drone: 'Drone',
    helicopter: 'Hélicoptère',
    ferry: 'Ferry',
    other: 'Autre',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Tableau de bord',
    goodMorning: 'Bonjour',
    goodAfternoon: 'Bon après-midi',
    goodEvening: 'Bonsoir',
    lastLogin: 'Dernière connexion',
    infrastructure: 'Infrastructure',
    transportAssets: 'Moyens de transport',
    treatmentFacilities: 'Établissements de soins',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistiques des demandes',
    viewAllRequests: 'Voir toutes les demandes',
    availableAssets: 'Moyens disponibles',
    seated: 'Assis',
    lying: 'Couchés',
    intensive: 'Soins intensifs',
    notifications: 'Notifications',
    markAllRead: 'Tout marquer comme lu',
    noNotifications: 'Aucune notification pour le moment',
    notifiedWhenActivity: 'Vous serez notifié lorsqu\'une nouvelle activité se produira',
    viewDetailsBtn: 'Voir les détails',
    nationUsers: 'Utilisateurs nationaux',
    user: 'Utilisateur',
    roles: 'Rôles',
    noUsersFound: 'Aucun utilisateur trouvé',
    participatingNations: 'Nations participantes',
    exerciseDisclaimer: 'Ce système est destiné uniquement à l\'exercice. Saisissez exclusivement des données simulées d\'exercice. Les flux de travail sont adaptés au scénario de l\'exercice et peuvent différer des procédures réelles. Les règles de sécurité informatique et de protection des données restent pleinement applicables.',
    notConfigured: 'Non configuré',
    requestCount: '{{count}} demande(s)',
    clickToView: 'Cliquer pour voir',
    systemAdministration: 'Administration système',
    exerciseControlTitle: 'Contrôle de l\'exercice',
    euCoordination: 'Coordination UE',
    transportPlanningTitle: 'Planification des transports',
    hubManagement: 'Gestion des hubs',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nouvelle demande',
    myDrafts: 'Mes brouillons',
    pendingReview: 'En attente de révision',
    activeTransports: 'Transports actifs',
    myPatients: 'Mes patients',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Demandes',
    newRequest: 'Nouvelle demande',
    createRequest: 'Créer une demande',
    editRequest: 'Modifier la demande',
    requestDetail: 'Détail de la demande',
    requestId: 'ID de la demande',
    fromNation: 'Nation d\'origine',
    toNation: 'Nation de destination',
    requestingNation: 'Nation demandeuse',
    receivingNation: 'Nation réceptrice',
    category: 'Catégorie',
    urgency: 'Urgence',
    status: 'Statut',
    patients: 'Patients',
    patientCount: 'Nombre de patients',
    offers: 'Offres',
    offerCount: 'Nombre d\'offres',
    created: 'Créée',
    updated: 'Mise à jour',
    submittedBy: 'Soumise par',
    reviewedBy: 'Révisée par',
    description: 'Description',
    medicalDetails: 'Détails médicaux',
    transportDetails: 'Détails du transport',
    additionalInfo: 'Informations complémentaires',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Point de départ',
    arrivalPoint: 'Point d\'arrivée',
    estimatedDeparture: 'Départ estimé',
    estimatedArrival: 'Arrivée estimée',
    submitForReview: 'Soumettre pour révision',
    publish: 'Publier',
    startSelection: 'Lancer la sélection',
    acceptOffer: 'Accepter l\'offre',
    markInTransit: 'Marquer en transit',
    markCompleted: 'Marquer comme terminée',
    closeRequest: 'Clôturer la demande',
    withdrawRequest: 'Retirer la demande',
    withdraw: 'Retirer',
    revertToDraft: 'Remettre en brouillon',
    deleteRequest: 'Supprimer la demande',
    duplicateRequest: 'Dupliquer la demande',
    createFollowUp: 'Créer une demande consolidée',
    followUpRequest: 'Demande consolidée',
    parentRequest: 'Demande originale',
    childRequests: 'Demandes consolidées',
    noRequests: 'Aucune demande trouvée',
    noOffers: 'Aucune offre pour le moment',
    addPatient: 'Ajouter un patient',
    removePatient: 'Retirer le patient',
    patientDetails: 'Détails du patient',
    contactPerson: 'Personne de contact',
    contactPhone: 'Téléphone de contact',
    contactEmail: 'E-mail de contact',
    specialRequirements: 'Exigences particulières',
    medicalEquipment: 'Équipement médical',
    accompaniment: 'Accompagnement',
    timeline: 'Chronologie',
    history: 'Historique',
    addComment: 'Ajouter un commentaire',
    writeComment: 'Écrire un commentaire...',
    postComment: 'Publier le commentaire',
    posting: 'Publication en cours...',
    noComments: 'Aucun commentaire pour le moment',
    coverageBar: 'Couverture',
    covered: 'couvert(s)',
    uncovered: 'non couvert(s)',
    filterByStatus: 'Filtrer par statut',
    filterByCategory: 'Filtrer par catégorie',
    filterByNation: 'Filtrer par nation',
    searchRequests: 'Rechercher des demandes...',
    confirmWithdraw: 'Êtes-vous sûr de vouloir retirer cette demande ?',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette demande ?',
    confirmPublish: 'Êtes-vous sûr de vouloir publier cette demande ? Elle sera visible par toutes les nations.',
    confirmStartSelection: 'Êtes-vous sûr de vouloir lancer la sélection ? Les nations pourront soumettre des offres.',
    warningStartSelection: 'Le lancement de la sélection rendra cette demande visible à toutes les nations participantes. Elles pourront soumettre des offres pour les patients de cette demande. Cette action est irréversible.',
    warningMakeOffer: 'En soumettant cette offre, vous engagez votre nation à fournir l\'assistance proposée. Cette action notifiera la nation demandeuse et le contrôle de l\'exercice.',
    saveDraft: 'Enregistrer le brouillon',
    saving: 'Enregistrement en cours...',
    saveAndSubmit: 'Enregistrer et soumettre',
    step: 'Étape {{number}}',
    generalInfo: 'Informations générales',
    patientInfo: 'Informations sur le patient',
    logisticsInfo: 'Informations logistiques',
    reviewSubmit: 'Vérification et soumission',
    requestTitle: 'Titre de la demande',
    requestDescription: 'Description de la demande',
    numberOfPatients: 'Nombre de patients',
    typeOfAssistance: 'Type d\'assistance',
    medicalTreatment: 'Traitement médical',
    transportAssistance: 'Assistance au transport',
    both: 'Les deux',
    treatmentOnly: 'Traitement uniquement',
    transportOnly: 'Transport uniquement',
    validationErrors: 'Veuillez corriger les erreurs suivantes :',
    fieldRequired: 'Ce champ est obligatoire',
    selectExitHub: 'Sélectionnez un hub de sortie',
    createExitHub: 'Créer un hub de sortie',
    backToRequests: 'Retour aux demandes',
    noRequestsFound: 'Aucune demande trouvée',
    createFirstRequest: 'Créez votre première demande pour commencer',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Offres',
    createOffer: 'Créer une offre',
    makeOffer: 'Faire une offre',
    manageOffers: 'Gérer les offres',
    offerDetail: 'Détail de l\'offre',
    offerId: 'ID de l\'offre',
    offeringNation: 'Nation offrante',
    offerType: 'Type d\'offre',
    treatment: 'Traitement',
    transport: 'Transport',
    combined: 'Combiné',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Offre de traitement',
    transportOffer: 'Offre de transport',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Sélectionner les patients',
    selectedPatients: 'Patients sélectionnés',
    patientSelection: 'Sélection des patients',
    offerConfiguration: 'Configuration de l\'offre',
    reviewOffer: 'Vérifier l\'offre',
    submitOffer: 'Soumettre l\'offre',
    submitting: 'Soumission en cours...',
    acceptOffer: 'Accepter l\'offre',
    rejectOffer: 'Rejeter l\'offre',
    withdrawOffer: 'Retirer l\'offre',
    noOffers: 'Aucune offre disponible',
    noOffer: 'No Offer',
    offerStatus: 'Statut de l\'offre',
    offerDate: 'Date de l\'offre',
    transportAsset: 'Moyen de transport',
    departureDate: 'Date de départ',
    arrivalDate: 'Date d\'arrivée',
    treatmentFacility: 'Établissement de soins',
    capacity: 'Capacité',
    availableCapacity: 'Capacité disponible',
    totalCapacity: 'Capacité totale',
    selectAsset: 'Sélectionner un moyen',
    selectFacility: 'Sélectionner un établissement',
    offerNotes: 'Notes de l\'offre',
    confirmAccept: 'Êtes-vous sûr de vouloir accepter cette offre ?',
    confirmReject: 'Êtes-vous sûr de vouloir rejeter cette offre ?',
    extendTransport: 'Prolonger le transport',
    transportExtension: 'Prolongation du transport',
    comparisonView: 'Vue comparative',
    shortlist: 'Présélection',
    addToShortlist: 'Ajouter à la présélection',
    removeFromShortlist: 'Retirer de la présélection',
    leaveConfirmTitle: 'Quitter cette page ?',
    leaveConfirmMessage: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?',
    stayOnPage: 'Rester sur la page',
    leavePage: 'Quitter la page',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transports',
    missionDetail: 'Détail du transport',
    missionId: 'ID du transport',
    missionStatus: 'Statut du transport',
    createMission: 'Créer un transport',
    overview: 'Vue d\'ensemble',
    patientsTab: 'Patients',
    transportsTab: 'Étapes de transport',
    treatmentTab: 'Traitement',
    reviewTab: 'Vérification',
    departure: 'Départ',
    arrival: 'Arrivée',
    origin: 'Origine',
    destination: 'Destination',
    stops: 'Arrêts',
    addStop: 'Ajouter un arrêt',
    removeStop: 'Supprimer l\'arrêt',
    stopName: 'Nom de l\'arrêt',
    stopType: 'Type d\'arrêt',
    estimatedTime: 'Heure estimée',
    actualTime: 'Heure réelle',
    asset: 'Moyen',
    driver: 'Conducteur',
    crew: 'Équipage',
    noMissions: 'Aucun transport trouvé',
    completeMission: 'Terminer le transport',
    cancelMission: 'Annuler le transport',
    startTransport: 'Démarrer le transport',
    missionChain: 'Chaîne de transport',
    linkedMissions: 'Transports liés',
    handover: 'Transfert',
    handoverPoint: 'Point de transfert',
    pickupPoint: 'Point de prise en charge',
    dropoffPoint: 'Point de dépose',
    searchTransports: 'Rechercher des transports...',
    readyAtHub: 'Prêt au hub',
    noAsset: 'Aucun moyen',
    deleteTransport: 'Supprimer le transport',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    patientsReady: 'Patients prêts',
    assetArrives: 'Arrivée du moyen',
    selectDateTime: 'Sélectionner date et heure',
    notSet: 'Non défini',
    transportDescription: 'Chaque transport représente un trajet d\'un véhicule du Transit Hub vers un Exit Hub.',
    arrived: 'arrivé',
    overdue: 'en retard',
    inTime: 'dans',
    speed: 'Vitesse',
    noStops: 'Aucun arrêt configuré pour ce transport.',
    completedSegment: 'Terminé',
    pendingSegment: 'En attente',
    calculateEta: 'Calculer l\'ETA',
    // Transport Planning Step
    transportPlanning: 'Planification du transport',
    patientsTotal: 'patients au total',
    patientsAssigned: 'assignés',
    patientsRemaining: 'restants',
    availableAssets: 'Moyens disponibles',
    assetAvailable: 'Disponible',
    assetBusy: 'Occupé',
    assetBusyUntil: 'Occupé jusqu\'à',
    routeConfig: 'Configuration de l\'itinéraire',
    startPoint: 'Point de départ (Transit Hub)',
    exitHubSelect: 'Exit Hub (Destination)',
    exitHubHint: 'Votre nation contrôle cet itinéraire',
    groupBy: 'Grouper par',
    groupByPriority: 'Priorité',
    groupByDependency: 'Dépendance',
    groupByMobility: 'Mobilité',
    groupByNone: 'Aucun regroupement',
    dragPatientsHint: 'Glissez les patients pour les assigner à un trajet',
    trips: 'Trajets',
    addTrip: 'Ajouter un trajet',
    returnTrip: 'Trajet retour',
    tripDeparture: 'Départ',
    tripArrival: 'Arrivée',
    capacityUsed: 'capacité utilisée',
    atCapacity: 'À capacité maximale',
    overCapacity: 'Capacité dépassée',
    seatsUsed: 'places utilisées',
    scheduleReturn: 'Planifier un trajet retour avec le même moyen',
    selectAssetFirst: 'Sélectionnez d\'abord un moyen',
    noTripsYet: 'Aucun trajet planifié. Créez un trajet pour commencer l\'assignation des patients.',
    seated: 'Assis',
    lying: 'Couchés',
    intensive: 'Soins intensifs',
    turnaroundTime: 'Temps de rotation',
    saveAndContinue: 'Enregistrer et continuer',
    capacityWarning80: 'Proche de la capacité ({{pct}}%)',
    capacityWarning100: 'Capacité maximale atteinte',
    capacityOverflow: '{{pct}}% de dépassement (tolérance de 20%)',
    capacityBlocked: 'Dépasse la tolérance de 20%',
    unassignedPatients: 'Non assignés',
    patientsSelected: 'sélectionné(s)',
    startPointNote: 'Défini par la nation hôte',
    treatmentDestination: 'Destinations de traitement',
    otherPoints: 'Autres points',
    dropPatientsHere: 'Déposez les patients ici',
    tripFull: 'Ce trajet est à capacité maximale.',
    assetSelected: 'Moyen sélectionné — cliquez Ajouter un trajet',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Patients',
    myPatients: 'Mes patients',
    patientId: 'ID du patient',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    dateOfBirth: 'Date de naissance',
    age: 'Âge',
    gender: 'Sexe',
    male: 'Masculin',
    female: 'Féminin',
    other: 'Autre',
    nationality: 'Nationalité',
    diagnosis: 'Diagnostic',
    condition: 'État',
    stable: 'Stable',
    critical: 'Critique',
    serious: 'Grave',
    treatmentNeeded: 'Traitement nécessaire',
    allergies: 'Allergies',
    medications: 'Médicaments',
    bloodType: 'Groupe sanguin',
    weight: 'Poids (kg)',
    infectious: 'Infectieux',
    mentalHealth: 'Santé mentale',
    mobility: 'Mobilité',
    ambulatory: 'Ambulatoire',
    wheelchair: 'Fauteuil roulant',
    stretcher: 'Brancard',
    intensive: 'Soins intensifs',
    oxygenRequired: 'Oxygène requis',
    ventilator: 'Ventilateur',
    medicalEscort: 'Escorte médicale',
    noPatients: 'Aucun patient trouvé',
    patientDetails: 'Détails du patient',
    medicalHistory: 'Antécédents médicaux',
    travelDocuments: 'Documents de voyage',
    passport: 'Passeport',
    pseudonymizedId: 'ID pseudonymisé',
    sensitiveData: 'Données sensibles',
    journey: 'Parcours du patient',
    assignedTo: 'Affecté à',
    currentLocation: 'Emplacement actuel',
    importPatients: 'Importer des patients',
    exportPatients: 'Exporter les patients',
    seated: 'Assis',
    lying: 'Couché',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Utilisateurs',
    createUser: 'Créer un utilisateur',
    editUser: 'Modifier l\'utilisateur',
    deleteUser: 'Supprimer l\'utilisateur',
    username: 'Nom d\'utilisateur',
    displayName: 'Nom affiché',
    email: 'E-mail',
    password: 'Mot de passe',
    role: 'Rôle',
    roles: 'Rôles',
    nation: 'Nation',
    active: 'Actif',
    lastLogin: 'Dernière connexion',
    createdAt: 'Créé',
    isNation: 'Nation',
    isEU: 'UE',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planificateur',
    isHub: 'Hub',
    isReadOnly: 'Lecture seule',
    noUsers: 'Aucun utilisateur trouvé',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
    resetPassword: 'Réinitialiser le mot de passe',
    generatePassword: 'Générer un mot de passe',
    searchUsers: 'Rechercher des utilisateurs...',
    userCreated: 'Utilisateur créé avec succès',
    userUpdated: 'Utilisateur mis à jour avec succès',
    userDeleted: 'Utilisateur supprimé avec succès',
    selectNation: 'Sélectionnez une nation',
    mustChangePassword: 'Doit changer le mot de passe à la prochaine connexion',
    flagImage: 'Image du drapeau',
    exportUsers: 'Exporter les utilisateurs',
    importUsers: 'Importer des utilisateurs',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Moyens de transport',
    createAsset: 'Créer un moyen',
    editAsset: 'Modifier le moyen',
    deleteAsset: 'Supprimer le moyen',
    assetName: 'Nom du moyen',
    assetType: 'Type de moyen',
    capacitySeated: 'Capacité (assis)',
    capacityLying: 'Capacité (couchés)',
    capacityIntensive: 'Capacité (soins intensifs)',
    owner: 'Propriétaire',
    operator: 'Opérateur',
    baseLocation: 'Emplacement de base',
    range: 'Autonomie',
    speed: 'Vitesse',
    noAssets: 'Aucun moyen trouvé',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce moyen ?',
    searchAssets: 'Rechercher des moyens...',
    assetCreated: 'Moyen créé avec succès',
    assetUpdated: 'Moyen mis à jour avec succès',
    assetDeleted: 'Moyen supprimé avec succès',
    exportAssets: 'Exporter les moyens',
    // Asset group labels
    aircraft: 'Avion',
    helicopter: 'Hélicoptère',
    ground: 'Terrestre',
    sea: 'Maritime',
    busy: 'Occupé',
    available: 'Disponible',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hubs',
    startPoints: 'Points de départ',
    createHub: 'Créer un hub',
    editHub: 'Modifier le hub',
    deleteHub: 'Supprimer le hub',
    hubName: 'Nom du hub',
    hubType: 'Type de hub',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Hub d\'entrée',
    airport: 'Aéroport',
    seaport: 'Port maritime',
    railStation: 'Gare ferroviaire',
    roadPoint: 'Point routier',
    ucpmClassification: 'Classification UCPM',
    icaoCode: 'Code ICAO',
    iataCode: 'Code IATA',
    noHubs: 'Aucun hub trouvé',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce hub ?',
    searchHubs: 'Rechercher des hubs...',
    nationAssignment: 'Attribution aux nations',
    assignNations: 'Attribuer des nations',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Établissements de soins',
    createFacility: 'Créer un établissement',
    editFacility: 'Modifier l\'établissement',
    deleteFacility: 'Supprimer l\'établissement',
    facilityName: 'Nom de l\'établissement',
    facilityType: 'Type d\'établissement',
    hospitalName: 'Nom de l\'hôpital',
    bedCapacity: 'Capacité en lits',
    specialties: 'Spécialités',
    availableBeds: 'Lits disponibles',
    totalBeds: 'Nombre total de lits',
    contactPerson: 'Personne de contact',
    noFacilities: 'Aucun établissement de soins trouvé',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet établissement ?',
    searchFacilities: 'Rechercher des établissements...',
    hubNationAssignment: 'Attribution hub-nation',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Plannings',
    createSchedule: 'Créer un planning',
    editSchedule: 'Modifier le planning',
    deleteSchedule: 'Supprimer le planning',
    scheduleName: 'Nom du planning',
    scheduleType: 'Type de planning',
    recurring: 'Récurrent',
    oneTime: 'Ponctuel',
    frequency: 'Fréquence',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    departureTime: 'Heure de départ',
    arrivalTime: 'Heure d\'arrivée',
    stops: 'Arrêts',
    addStop: 'Ajouter un arrêt',
    noSchedules: 'Aucun planning trouvé',
    bookings: 'Réservations',
    timeline: 'Chronologie',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notifications',
    markAllRead: 'Tout marquer comme lu',
    markAsRead: 'Marquer comme lu',
    markAsUnread: 'Marquer comme non lu',
    noNotifications: 'Aucune notification',
    viewAll: 'Voir toutes les notifications',
    settings: 'Paramètres de notification',
    emailNotifications: 'Notifications par e-mail',
    inAppNotifications: 'Notifications dans l\'application',
    notifyOn: 'Me notifier pour',
    requestCreated: 'Nouvelle demande',
    requestPublished: 'Demande publiée',
    requestClosed: 'Demande clôturée',
    requestCompleted: 'Demande terminée',
    commentAdded: 'Nouveau commentaire',
    offerReceived: 'Offre reçue',
    offerAccepted: 'Offre acceptée',
    statusChanged: 'Statut modifié',
    selectionStarted: 'Sélection lancée',
    missionCreated: 'Transport créé',
    missionStatusUpdated: 'Transport mis à jour',
    transportPartnerNamed: 'Partenaire de transport',
    transportExtensionReceived: 'Prolongation de transport',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Paramètres',
    general: 'Général',
    system: 'Système',
    email: 'E-mail',
    sync: 'Synchronisation',
    security: 'Sécurité',
    appearance: 'Apparence',
    systemName: 'Nom du système',
    systemEmail: 'E-mail du système',
    maintenanceMode: 'Mode maintenance',
    readOnlyMode: 'Mode lecture seule',
    emailEnabled: 'E-mail activé',
    smtpHost: 'Hôte SMTP',
    smtpPort: 'Port SMTP',
    smtpUser: 'Utilisateur SMTP',
    smtpPassword: 'Mot de passe SMTP',
    senderEmail: 'E-mail de l\'expéditeur',
    senderName: 'Nom de l\'expéditeur',
    testEmail: 'Envoyer un e-mail de test',
    syncEnabled: 'Synchronisation activée',
    syncUrl: 'URL de synchronisation',
    syncApiKey: 'Clé API de synchronisation',
    settingsSaved: 'Paramètres enregistrés avec succès',
    helpdesk: 'Support technique',
    helpdeskTitle: 'Titre du support technique',
    helpdeskEmail: 'E-mail du support technique',
    helpdeskPhone: 'Téléphone du support technique',
    helpdeskInfo: 'Informations du support technique',
    realLifeSupport: 'Support en situation réelle',
    trainingMode: 'Mode entraînement',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Journal d\'audit',
    action: 'Action',
    user: 'Utilisateur',
    target: 'Cible',
    details: 'Détails',
    timestamp: 'Horodatage',
    ipAddress: 'Adresse IP',
    noLogs: 'Aucun journal d\'audit trouvé',
    searchLogs: 'Rechercher dans les journaux...',
    filterByAction: 'Filtrer par action',
    filterByUser: 'Filtrer par utilisateur',
    exportLogs: 'Exporter les journaux',
    exportCsv: 'Exporter en CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Contrôle de l\'exercice',
    currentDay: 'Jour actuel',
    exerciseDay: 'Jour d\'exercice',
    nextDay: 'Jour suivant',
    previousDay: 'Jour précédent',
    resetExercise: 'Réinitialiser l\'exercice',
    startExercise: 'Démarrer l\'exercice',
    endExercise: 'Terminer l\'exercice',
    dayReset: 'Réinitialisation du jour',
    confirmReset: 'Êtes-vous sûr de vouloir réinitialiser le jour d\'exercice ? Cela supprimera toutes les données du jour en cours.',
    resetInProgress: 'Réinitialisation en cours...',
    maintenanceMode: 'Mode maintenance',
    enableMaintenance: 'Activer la maintenance',
    disableMaintenance: 'Désactiver la maintenance',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Synchronisation des données',
    syncStatus: 'État de la synchronisation',
    lastSync: 'Dernière synchronisation',
    pendingItems: 'Éléments en attente',
    syncNow: 'Synchroniser maintenant',
    syncing: 'Synchronisation en cours...',
    syncSuccess: 'Synchronisation terminée avec succès',
    syncFailed: 'Échec de la synchronisation',
    outbox: 'Boîte d\'envoi',
    inbox: 'Boîte de réception',
    configuration: 'Configuration',
    targetUrl: 'URL cible',
    apiKey: 'Clé API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Carte',
    layers: 'Couches',
    requests: 'Demandes',
    hubs: 'Hubs',
    facilities: 'Établissements',
    routes: 'Itinéraires',
    showAll: 'Tout afficher',
    hideAll: 'Tout masquer',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    resetView: 'Réinitialiser la vue',
    satellite: 'Satellite',
    terrain: 'Terrain',
    offline: 'Hors ligne',
    online: 'En ligne',
    tilesOffline: 'Les tuiles de carte sont servies localement',
    tilesOnline: 'Les tuiles de carte sont chargées depuis des serveurs en ligne',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistiques',
    overview: 'Vue d\'ensemble',
    requestsByStatus: 'Demandes par statut',
    requestsByCategory: 'Demandes par catégorie',
    requestsByNation: 'Demandes par nation',
    offersByStatus: 'Offres par statut',
    patientsByCondition: 'Patients par état',
    transportsByStatus: 'Transports par statut',
    timeline: 'Chronologie',
    totalRequests: 'Total des demandes',
    totalOffers: 'Total des offres',
    totalPatients: 'Total des patients',
    totalTransports: 'Total des transports',
    averageResponseTime: 'Temps de réponse moyen',
    completionRate: 'Taux d\'achèvement',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistiques de l\'exercice',
    overview: 'Vue d\'ensemble',
    byCategory: 'Par catégorie',
    byNation: 'Par nation',
    byDay: 'Par jour',
    totalPatientsMoved: 'Total de patients transférés',
    totalRequestsProcessed: 'Total de demandes traitées',
    averageProcessingTime: 'Temps de traitement moyen',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagramme de flux',
    sankey: 'Sankey',
    nodeGraph: 'Graphe de nœuds',
    refresh: 'Actualiser',
    noData: 'Aucune donnée de flux disponible',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'À propos',
    version: 'Version',
    systemInfo: 'Informations système',
    buildDate: 'Date de compilation',
    environment: 'Environnement',
    description: 'ARCOS — Système avancé de communication des demandes',
    subtitle: 'Assistance aux victimes et opérations médicales',
    whatIsArcos: 'Qu\'est-ce qu\'ARCOS ? – Explication pour les participants à l\'exercice',
    arcosDesc1: 'ARCOS est un outil numérique utilisé dans cet exercice pour soutenir et structurer la communication internationale, les demandes et les processus de coordination entre les acteurs participants. Il est important de comprendre qu\'ARCOS n\'est pas un système opérationnel et ne remplace pas les plateformes réelles telles que CECIS (Système commun de communication et d\'information d\'urgence) ou EWRS (Système d\'alerte précoce et de réaction).',
    arcosDesc2: 'ARCOS fournit plutôt une représentation simplifiée et orientée exercice des principes de base de ces systèmes. Son objectif est de permettre aux participants de travailler dans un cadre commun et cohérent pendant l\'exercice, sans nécessiter l\'accès à des environnements protégés ou opérationnels.',
    arcosUsedFor: 'Pendant l\'exercice, ARCOS est utilisé pour représenter des processus typiques tels que :',
    arcosUsedForItem1: 'la soumission et la gestion des demandes d\'assistance (p. ex. soutien médical, personnel ou matériel),',
    arcosUsedForItem2: 'la coordination et la réponse aux offres de soutien d\'autres nations ou organisations,',
    arcosUsedForItem3: 'le suivi du statut et de la progression des demandes,',
    arcosUsedForItem4: 'et la représentation simplifiée des flux de transport ou d\'évacuation.',
    arcosDesc3: 'Les flux de travail dans ARCOS sont intentionnellement simplifiés et adaptés aux objectifs de formation spécifiques de l\'exercice. De plus, ARCOS inclut certaines fonctions qui n\'existent pas dans les systèmes réels mais qui sont utiles à des fins de formation et de discussion. Cela permet à l\'exercice de se concentrer sur la prise de décision, la coordination et la coopération plutôt que sur les détails techniques du système.',
    arcosDesc4: 'L\'objectif d\'ARCOS n\'est pas de simuler un système réel parfait ou complet. Il vise plutôt à fournir une compréhension claire, structurée et partagée du fonctionnement des processus de coordination multinationale en principe. ARCOS est destiné à soutenir l\'exercice, rendre la communication transparente et aider les participants à se concentrer sur les objectifs de l\'exercice.',
    arcosDesc5: 'Si certains éléments ou flux de travail dans ARCOS diffèrent des procédures réelles que vous connaissez peut-être, c\'est normal. ARCOS reflète la logique de l\'exercice, et non la complexité opérationnelle complète de systèmes tels que CECIS ou EWRS.',
    facilitatedBy: 'Facilité par le MMCC-E',
    dhcInitiative: 'Le Digital Health Corner (DHC) est une initiative conjointe de :',
    dhcAuthor1: 'Sven Giegerich — Forces armées allemandes',
    dhcAuthor2: 'Mohamad Haji — Défense belge',
    dhcConviction: 'Née de la conviction que l\'innovation prospère là où la passion rencontre le pragmatisme.',
    dhcInspired: 'Inspirés par l\'étincelle initiale allumée par le MMCC-E, nous nous sommes lancés dans la création de solutions simples mais efficaces basées sur les systèmes existants – des outils qui rendent les exercices sur table (TTX) plus efficaces, réalistes et accessibles.',
    dhcLove: 'Nous le faisons parce que nous aimons notre travail et nous croyons que les idées numériques peuvent remodeler la collaboration dans le domaine de la santé militaire.',
    dhcOpen: 'Le DHC est une plateforme ouverte : libre de hiérarchies, ouverte aux idées, animée par la curiosité et un esprit de collaboration. Nous recherchons des innovateurs partageant notre enthousiasme – des personnes qui veulent penser, construire et créer ensemble.',
    dhcClosing: 'Digital Health Corner – là où la curiosité rencontre la collaboration.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Documentation',
    gettingStarted: 'Prise en main',
    userGuide: 'Guide de l\'utilisateur',
    faq: 'FAQ',
    troubleshooting: 'Dépannage',
    apiReference: 'Référence API',
    downloadTemplate: 'Télécharger le modèle',
    overviewDesc: 'CAMO26 (Opérations médicales d\'assistance civilo-militaire 2026) est un système de simulation du flux CECIS. En tant qu\'utilisateur <strong>Nation</strong>, vous pouvez créer et gérer des demandes d\'assistance, communiquer avec d\'autres nations et coordonner les opérations de soutien médical.',
    dashboardDesc: 'Le tableau de bord fournit une vue d\'ensemble de toutes les demandes du système et affiche les statistiques par statut. Cliquez sur n\'importe quelle carte de statistiques pour afficher les demandes filtrées.',
    navigationInfo: 'Informations de navigation',
    navDashboard: 'Tableau de bord - Vue d\'ensemble du système et statistiques',
    navRequests: 'Demandes - Voir toutes les demandes en format liste',
    navNewRequest: 'Nouvelle demande - Créer une nouvelle demande d\'assistance',
    navNotifications: 'Notifications - L\'icône cloche dans l\'en-tête affiche les nouvelles activités',
    step1Title: 'Étape 1 : Informations de base',
    step1Item1: 'Cliquez sur <strong>« Nouvelle demande »</strong> dans le menu de navigation',
    step1Item2: 'Entrez un <strong>Titre</strong> descriptif pour votre demande',
    step1Item3: 'Fournissez une <strong>Description</strong> détaillée de l\'assistance nécessaire',
    step1Item4: 'Sélectionnez la <strong>Catégorie</strong> :',
    catMedevac: 'MEDEVAC - Évacuation médicale de patients',
    catPersonnel: 'PERSONNEL - Demande de personnel médical',
    catEquipment: 'ÉQUIPEMENT - Demande d\'équipement ou de fournitures médicales',
    catOther: 'AUTRE - Autres types d\'assistance',
    step1Item5: 'Définissez le niveau d\'<strong>Urgence</strong> (FAIBLE, NORMAL, ÉLEVÉ)',
    step1Item6: 'Définissez éventuellement une date limite de <strong>« Réponse avant »</strong>',
    step2Title: 'Étape 2 : Ajouter les données patient (MEDEVAC uniquement)',
    step2Desc: 'Pour les demandes MEDEVAC, vous pouvez ajouter les informations patient :',
    step2ManualEntry: 'Saisie manuelle - Remplissez le formulaire patient pour chaque individu',
    step2ExcelUpload: 'Téléversement Excel - Téléversez un fichier Excel pré-rempli avec les données patient',
    step2ExcelItem1: 'Téléchargez le modèle depuis la page de demande',
    step2ExcelItem2: 'Remplissez les détails patient en suivant le format',
    step2ExcelItem3: 'Téléversez le fichier complété',
    step3Title: 'Étape 3 : Soumettre pour examen',
    step3Desc: 'Une fois votre demande complète, soumettez-la pour examen par l\'UE. La demande passe au statut <strong>« EN_EXAMEN »</strong> et les coordinateurs UE sont notifiés.',
    requestWorkflow: 'Flux de la demande',
    workflowDraft: 'Création initiale - visible uniquement par vous',
    workflowReview: 'Soumis à l\'UE pour approbation',
    workflowPublished: 'Visible par toutes les nations - peut recevoir des offres',
    workflowTransit: 'Offre acceptée - assistance en cours',
    workflowCompleted: 'Assistance livrée avec succès',
    workflowNote: '<strong>Note :</strong> Les coordinateurs UE peuvent également mettre les demandes au statut <strong>CLÔTURÉ</strong> si nécessaire.',
    viewingRequests: 'Consulter et gérer les demandes',
    ownRequests: 'Vos propres demandes',
    ownRequestItem1: 'Voir toutes vos demandes quel que soit le statut',
    ownRequestItem2: 'Modifier les demandes BROUILLON avant soumission',
    ownRequestItem3: 'Suivre les changements de statut et mises à jour',
    ownRequestItem4: 'Accepter les offres d\'autres nations',
    ownRequestItem5: 'Marquer les demandes comme COMPLÉTÉES lorsque l\'assistance est livrée',
    otherRequests: 'Demandes des autres nations',
    otherRequestItem1: 'Voir toutes les demandes PUBLIÉES d\'autres nations',
    otherRequestItem2: 'Ajouter des commentaires pour discuter des détails',
    otherRequestItem3: 'Soumettre des offres pour fournir de l\'assistance',
    otherRequestItem4: 'Suivre quelles demandes ont été satisfaites',
    fullOffer: 'Offre complète',
    fullOfferDesc: 'Vous pouvez répondre à l\'intégralité de la demande :',
    fullOfferItem1: 'Ouvrir une demande PUBLIÉE d\'une autre nation',
    fullOfferItem2: 'Cliquer sur <strong>« Faire une offre »</strong>',
    fullOfferItem3: 'Décrire ce que vous pouvez fournir',
    fullOfferItem4: 'Soumettre l\'offre',
    partialOffer: 'Offre partielle (MEDEVAC uniquement)',
    partialOfferDesc: 'Pour les demandes MEDEVAC, vous pouvez proposer de prendre certains patients :',
    partialOfferItem1: 'Sélectionner des patients spécifiques dans la liste',
    partialOfferItem2: 'Décrire votre capacité et vos compétences',
    partialOfferItem3: 'Soumettre l\'offre partielle',
    offerImportant: '<strong>Important :</strong> La nation demandeuse doit accepter votre offre avant qu\'elle ne devienne active.',
    commentsUsage: 'Utilisez les commentaires sur les demandes PUBLIÉES pour :',
    commentItem1: 'Poser des questions sur les exigences',
    commentItem2: 'Clarifier les détails avant de faire une offre',
    commentItem3: 'Coordonner la logistique et le calendrier',
    commentItem4: 'Partager les mises à jour pendant l\'exécution',
    notifDesc: 'Vous recevez des notifications pour :',
    notifItem1: 'Nouvelles demandes publiées d\'autres nations',
    notifItem2: 'Commentaires sur vos demandes ou demandes avec lesquelles vous avez interagi',
    notifItem3: 'Offres reçues sur vos demandes',
    notifItem4: 'Changements de statut de vos demandes',
    notifItem5: 'Acceptation/refus d\'offres',
    notifBell: 'Vérifiez l\'icône cloche dans l\'en-tête pour voir les notifications. Le badge indique le nombre non lu.',
    requestIdFormat: 'Format de l\'identifiant de demande',
    requestIdDesc: 'Chaque demande reçoit un identifiant unique au format : <code>XXX-AAAA-NNN</code>',
    requestIdPart1: '<strong>XXX</strong> - Le code ISO 3166-1 alpha-3 de votre nation (ex. DEU, FRA, GBR)',
    requestIdPart2: '<strong>AAAA</strong> - L\'année en cours',
    requestIdPart3: '<strong>NNN</strong> - Numéro séquentiel pour votre nation cette année',
    requestIdExample: '<strong>Exemple :</strong> <code>DEU-2025-001</code> est la première demande de l\'Allemagne en 2025',
    bestPractices: 'Bonnes pratiques',
    effectiveRequests: 'Créer des demandes efficaces',
    effectiveItem1: 'Utilisez des titres clairs et descriptifs',
    effectiveItem2: 'Fournissez des détails complets dans la description',
    effectiveItem3: 'Définissez des niveaux d\'urgence réalistes',
    effectiveItem4: 'Pour MEDEVAC : incluez des informations patient précises',
    effectiveItem5: 'Fixez des délais appropriés pour les réponses',
    collaboration: 'Collaboration',
    collabItem1: 'Répondez rapidement aux commentaires sur vos demandes',
    collabItem2: 'Examinez soigneusement les offres avant d\'accepter',
    collabItem3: 'Mettez à jour le statut de la demande au fur et à mesure de l\'évolution',
    collabItem4: 'Marquez les demandes comme COMPLÉTÉES lorsque l\'assistance est livrée',
    collabItem5: 'Communiquez tout changement ou problème par les commentaires',
    systemEtiquette: 'Étiquette du système',
    etiquetteItem1: 'Ne soumettez les demandes pour examen que lorsqu\'elles sont complètes',
    etiquetteItem2: 'Ne créez pas de demandes en double',
    etiquetteItem3: 'Utilisez des niveaux d\'urgence appropriés - réservez ÉLEVÉ aux véritables urgences',
    etiquetteItem4: 'Clôturez ou complétez les demandes qui ne sont plus nécessaires',
    supportDesc: 'Pour des problèmes techniques ou des questions sur l\'utilisation du système, veuillez contacter :',
    supportContact: 'Centre multinational de coordination médicale - Europe (MMCC-E)',
    importantNotice: 'Avis important',
    importantNoticeText1: 'Ceci est un système de simulation à des fins de formation et d\'exercice uniquement.',
    importantNoticeText2: 'CAMO26 simule le flux de base de CECIS (Système commun de communication et d\'information d\'urgence). De nombreuses fonctions CECIS ne sont pas représentées ici. Ce système est conçu pour les exercices sur table (TTX) et ne doit pas être utilisé pour des opérations d\'urgence réelles.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Importation de patients',
    uploadFile: 'Téléverser un fichier',
    selectFile: 'Sélectionner un fichier',
    preview: 'Aperçu',
    importNow: 'Importer maintenant',
    importing: 'Importation en cours...',
    importSuccess: '{{count}} patient(s) importé(s) avec succès',
    importFailed: 'Échec de l\'importation',
    downloadTemplate: 'Télécharger le modèle',
    dragDrop: 'Glissez-déposez un fichier ici, ou cliquez pour sélectionner',
    supportedFormats: 'Formats pris en charge : XLSX, XLS, CSV',
    rowsFound: '{{count}} ligne(s) trouvée(s)',
    validRows: '{{count}} ligne(s) valide(s)',
    invalidRows: '{{count}} ligne(s) invalide(s)',
    duplicateRows: '{{count}} ligne(s) en doublon',
    previewData: 'Aperçu des données',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planification des transports',
    planRoute: 'Planifier l\'itinéraire',
    routeBuilder: 'Constructeur d\'itinéraire',
    addWaypoint: 'Ajouter un point de passage',
    removeWaypoint: 'Supprimer le point de passage',
    estimatedDuration: 'Durée estimée',
    distance: 'Distance',
    selectVehicle: 'Sélectionner un véhicule',
  },

  transportBooking: {
    title: 'Réservation de transport',
    bookTransport: 'Réserver un transport',
    availableSlots: 'Créneaux disponibles',
    bookingConfirmed: 'Réservation confirmée',
    cancelBooking: 'Annuler la réservation',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planification des capacités',
    totalCapacity: 'Capacité totale',
    usedCapacity: 'Capacité utilisée',
    availableCapacity: 'Capacité disponible',
    utilizationRate: 'Taux d\'utilisation',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Modèles de moyens',
    dayTemplates: 'Modèles de journée',
    createTemplate: 'Créer un modèle',
    editTemplate: 'Modifier le modèle',
    deleteTemplate: 'Supprimer le modèle',
    templateName: 'Nom du modèle',
    applyTemplate: 'Appliquer le modèle',
    noTemplates: 'Aucun modèle trouvé',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
    confirmApply: 'Êtes-vous sûr de vouloir appliquer ce modèle ? Cela écrasera les données existantes.',
    exportTemplates: 'Exporter les modèles',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Bandeau d\'annonces',
    createAnnouncement: 'Créer une annonce',
    editAnnouncement: 'Modifier l\'annonce',
    deleteAnnouncement: 'Supprimer l\'annonce',
    message: 'Message',
    startTime: 'Heure de début',
    endTime: 'Heure de fin',
    active: 'Active',
    noAnnouncements: 'Aucune annonce',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette annonce ?',
  },

  // ============================================================
  // COMPONENTS — Chaînes des composants réutilisables
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Rechercher...',
      noResults: 'Aucun résultat trouvé',
      showing: 'Affichage de {{from}} à {{to}} sur {{total}}',
      rowsPerPage: 'Lignes par page',
      previousPage: 'Page précédente',
      nextPage: 'Page suivante',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Confirmer',
      cancel: 'Annuler',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Modifications non enregistrées',
      message: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter cette page ?',
      stay: 'Rester sur la page',
      leave: 'Quitter la page',
    },
    // EmptyState
    emptyState: {
      noData: 'Aucune donnée disponible',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Une erreur est survenue',
      message: 'Une erreur inattendue s\'est produite. Veuillez essayer d\'actualiser la page.',
      retry: 'Réessayer',
    },
    // ExportButton
    exportButton: {
      export: 'Exporter',
      exporting: 'Exportation en cours...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Imprimer',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Brouillon',
      review: 'Révision',
      published: 'Publiée',
      selection: 'Sélection',
      inTransit: 'En transit',
      completed: 'Terminée',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Instance en ligne',
      message: 'Mode lecture seule. Les données sont synchronisées depuis le serveur principal.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Vous consultez en tant que',
      loggedInAs: 'connecté en tant que {{nation}}',
      returnTo: 'Retour à {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Rechercher des pages, demandes, transports...',
      searching: 'Recherche en cours...',
      noResults: 'Aucun résultat pour « {{query}} »',
      navigate: 'Naviguer',
      select: 'Sélectionner',
      close: 'Fermer',
      pages: {
        dashboard: 'Tableau de bord',
        requests: 'Demandes',
        transports: 'Transports',
        map: 'Carte',
        myPatients: 'Mes patients',
        flowDiagram: 'Diagramme de flux',
        statistics: 'Statistiques',
        assets: 'Moyens de transport',
        startPoints: 'Points de départ / Hubs',
        treatmentFacilities: 'Établissements de soins',
        users: 'Utilisateurs',
        settings: 'Paramètres',
        auditLogs: 'Journal d\'audit',
        exerciseControl: 'Contrôle de l\'exercice',
        dataSync: 'Synchronisation des données',
        patientImport: 'Importation de patients',
        notifications: 'Notifications',
        documentation: 'Documentation',
      },
      actions: {
        importPatientsJson: 'Importer des patients (JSON)',
        importPatientsExcel: 'Importer des patients (Excel)',
        importUsers: 'Importer des utilisateurs (Excel)',
        importAssetTemplates: 'Importer des modèles d\'assets (Excel)',
        importDayTemplates: 'Importer des entrées de jour (Excel)',
        exportRequests: 'Exporter les demandes (Excel)',
        exportPatients: 'Exporter les patients (Excel)',
        exportUsers: 'Exporter les utilisateurs (Excel)',
        exportCredentials: 'Exporter les identifiants (PDF)',
        exportAuditExcel: 'Exporter le journal d\'audit (Excel)',
        exportAuditPdf: 'Exporter le journal d\'audit (PDF)',
        pagePatientImport: 'Page Importation de patients',
        pageRequestDetail: 'Page Détail de la demande',
        pageUsers: 'Page Gestion des utilisateurs',
        pageAssetTemplates: 'Page Modèles d\'assets',
        pageDayTemplates: 'Page Modèles de jour',
        pageRequests: 'Page Liste des demandes',
        pageAuditLogs: 'Page Journal d\'audit',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Session expirant bientôt',
      message: 'Votre session expirera dans <strong>{{time}}</strong>. Veuillez enregistrer votre travail et vous reconnecter pour continuer.',
      dismiss: 'Fermer',
      logoutNow: 'Se déconnecter maintenant',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Sélectionnez 4 fuseaux horaires',
      configure: 'Configurer les fuseaux horaires',
      reset: 'Réinitialiser',
      apply: 'Appliquer',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Choisir un emplacement',
      latitude: 'Latitude',
      longitude: 'Longitude',
      clickToSelect: 'Cliquez sur la carte pour sélectionner un emplacement',
    },
    // Modal
    modal: {
      close: 'Fermer',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Accueil',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Maintenance du système',
    message: 'Le système est en cours de réinitialisation pour le prochain jour d\'exercice. Veuillez patienter jusqu\'à la fin du processus.',
    autoRefresh: 'Cette page se rafraîchira automatiquement lorsque le système sera de nouveau disponible.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Brouillon',
      planned: 'Planifié',
      active: 'Actif',
      inTransit: 'En transit',
      completed: 'Terminé',
      cancelled: 'Annulé',
    },
    actions: {
      USER_LOGIN: 'Connexion utilisateur',
      USER_LOGOUT: 'Déconnexion utilisateur',
      USER_CREATED: 'Utilisateur créé',
      USER_UPDATED: 'Utilisateur mis à jour',
      USER_DELETED: 'Utilisateur supprimé',
      REQUEST_CREATED: 'Demande créée',
      REQUEST_UPDATED: 'Demande mise à jour',
      REQUEST_SUBMITTED: 'Demande soumise',
      REQUEST_PUBLISHED: 'Demande publiée',
      REQUEST_CLOSED: 'Demande clôturée',
      REQUEST_COMPLETED: 'Demande complétée',
      OFFER_CREATED: 'Offre créée',
      OFFER_UPDATED: 'Offre mise à jour',
      OFFER_ACCEPTED: 'Offre acceptée',
      OFFER_DELETED: 'Offre supprimée',
      MISSION_CREATED: 'Mission créée',
      MISSION_UPDATED: 'Mission mise à jour',
      MISSION_STATUS_UPDATED: 'Statut mission',
      MISSION_SPLIT: 'Mission divisée',
      MISSION_DELETED: 'Mission supprimée',
      COMMENT_CREATED: 'Commentaire créé',
      TRANSPORT_CREATED: 'Transport créé',
      TRANSPORT_COMPLETED: 'Transport terminé',
      SELECTION_STARTED: 'Sélection démarrée',
      SELECTION_ENDED: 'Sélection terminée',
      FILE_UPLOADED: 'Fichier téléversé',
      PATIENT_IDS_UPDATED: 'IDs patients mis à jour',
      SCHEDULE_CREATED: 'Planning créé',
      BOOKING_CREATED: 'Réservation créée',
      EXERCISE_DAY_ACTIVATED: 'Jour activé',
      EXERCISE_DAY_RESET: 'Jour réinitialisé',
      SETTING_UPDATED: 'Paramètre mis à jour',
      PATIENTS_IMPORTED: 'Patients importés',
      PATIENTS_EXCLUDED: 'Patients exclus',
      PATIENTS_ADDED: 'Patients ajoutés',
      REQUEST_DELETED: 'Demande supprimée',
      REQUEST_REVERTED_TO_DRAFT: 'Remis en brouillon',
    },
    transportMode: {
      SEATED: 'Assis',
      LYING: 'Couché',
      TBA: 'À déterminer',
    },
    dependency: {
      LOW: 'Faible',
      MEDIUM: 'Moyen',
      HIGH: 'Élevé',
      TBA: 'À déterminer',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'Tableau de bord santé système',
    unableToLoad: 'Impossible de charger les données de santé',
    retry: 'Réessayer',
    refresh: 'Actualiser',
    refreshFailed: 'Échec de l\'actualisation',
    auto: 'Auto',
    manual: 'Manuel',
    disableAutoRefresh: 'Désactiver l\'actualisation automatique',
    enableAutoRefresh: 'Activer l\'actualisation automatique (30s)',
    systemOverview: 'Vue d\'ensemble du système',
    uptime: 'Disponibilité',
    memory: 'Mémoire',
    dbLatency: 'Latence BD',
    serverTime: 'Heure serveur',
    activityToday: 'Activité aujourd\'hui',
    activeNations: 'Nations actives',
    requestsCreated: 'Demandes créées',
    patients: 'Patients',
    missionsCreated: 'Missions créées',
    servicesStatus: 'Statut des services',
    requestPipeline: 'Pipeline des demandes',
    noRequests: 'Aucune demande',
    staleDrafts: 'Brouillons périmés (>24h)',
    reviewBottleneck: 'Goulot d\'examen (>48h)',
    publishedNoOffers: 'Publiées sans offres',
    dataConsistency: 'Vérifications de cohérence des données',
    overallStatus: 'Statut global',
    healthy: 'Sain',
    warnings: 'Avertissements',
    critical: 'Critique',
    check: 'Vérification',
    issues: 'Problèmes',
    noConsistencyChecks: 'Aucune vérification de cohérence disponible',
    databaseRecords: 'Enregistrements de la base de données',
    exerciseStatus: 'Statut de l\'exercice',
    activeDay: 'Jour actif',
    noActiveDay: 'Aucun jour actif',
    templates: 'Modèles',
    lastActivation: 'Dernière activation',
    never: 'Jamais',
    recentAuditLog: 'Journal d\'audit récent',
    last10: '10 derniers',
    timestamp: 'Horodatage',
    user: 'Utilisateur',
    action: 'Action',
    resource: 'Ressource',
    noRecentAudit: 'Aucune entrée d\'audit récente',
    justNow: 'à l\'instant',
    services: {
      database: 'Base de données',
      email: 'Email',
      sync: 'Synchronisation',
      notifications: 'Notifications',
      maintenanceMode: 'Mode maintenance',
      trainingMode: 'Mode entraînement',
      connectionFailed: 'Connexion échouée',
      enabledSmtp: 'Activé & SMTP configuré',
      enabledNoSmtp: 'Activé mais SANS SMTP',
      disabled: 'Désactivé',
      staleUnread: '{{count}} non lus périmés (>7j)',
      active: 'ACTIF',
      off: 'Arrêt',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Au moins 10 caractères',
    uppercase: '1 lettre majuscule',
    lowercase: '1 lettre minuscule',
    digit: '1 chiffre',
    special: '1 caractère spécial',
  },
};

export default fr;
